/*
 * 戒导航 · 知识库审核（jiedh/wiki-review）前台 JS 总出口
 *
 * 设计依据：doc/知识库内容审核设计方案.md §7.3「回执与通知」/ §9.1「作者侧体验」。
 *
 * 运行范围：论坛前台（SPA）。本扩展**没有**后台 JS 入口 ——
 *   后台审核队列（「知识库」页签）由 packages/review 的 admin 入口统一渲染，
 *   本包只提供数据来源接口（见 packages/wiki-review/src/Source/WikiArticleSource.php）。
 *
 * ⚠️ 关键：Flarum 的 Application::bootExtensions() 只读取扩展模块的 `extend` 键，
 * 所以这里必须写 `export { default as extend } from './extend';`，而不是默认导出。
 */
import app from 'flarum/forum/app';

// 扩展声明：注册「知识库审核结果」通知卡片 + 回执模型（见 ./extend.ts）
export { default as extend } from './extend';
app.initializers.add('jiedh-wiki-review', () => {
  // 本模块前台无需额外初始化动作：
  //   - 通知组件通过 Extend.Notification().add() 注册（见 ./extend.ts）；
  //   - 点击通知的跳转、驳回理由展示全部在组件内完成。
});